<template>
  <div style="overflow-x: auto; overflow-y: hidden">
    <v-card class="ma-6 mb-0 pa-6" v-if="isDisplayFilter" outlined>
      <ClassTimeTableFilter @onFilterChanged="getClassSlots" />
    </v-card>
    <h2 class="py-6 text-center" v-else>Thời khóa biểu lớp {{ profile.ownClasses[0].title }}</h2>
    <StudentTimeTableTable v-if="selectedClassId && isDisplayFilter" :classData="classData" />
    <TimeTableBlankView type="class" v-if="!selectedClassId && isDisplayFilter" class="ma-6 pa-6" />
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'
import ClassTimeTableFilter from '../../../modules/timeTable/ClassTimeTableFilter.vue'
import TimeTableBlankView from '@/modules/timeTable/TimeTableBlankView.vue'
import StudentTimeTableTable from './StudentTimeTableTable.vue'
import get from 'lodash-es/get'
import moment from 'moment'

export default {
  components: {
    ClassTimeTableFilter,
    TimeTableBlankView,
    StudentTimeTableTable,
  },
  data() {
    return {
      grade: null,
      selectedClassId: '',
      createState: false,
      schedule: [],
      scheduleType: 'weekly-schedule',
      classData: {},
      teacher: [],
    }
  },
  computed: {
    ...mapState('timeTable', ['classSlots', 'teacherSlots']),
    ...mapState('teaching', ['classSlots', 'teacherSlots']),
    ...mapGetters('auth', ['profile', 'role']),
    isDisplayFilter() {
      if (this.role.type === 'teacher' && this.profile.ownClasses && this.profile.ownClasses.length === 1) {
        return false
      }
      return true
    },
  },
  async mounted() {
    if (!this.isDisplayFilter) {
      this.selectedClassId = this.profile.ownClasses[0].id
      await this.fetchClassSlots({ class: this.selectedClassId })
    }
  },
  methods: {
    ...mapActions('timeTable', ['fetchClassSlots', 'fetchTeacherSlots', 'removeSlot', 'setSelectedClassId']),
    ...mapActions('class', ['fetchOneClass']),
    ...mapActions('lesson', ['fetchLessons']),
    ...mapActions('teaching', ['fetchTeachings']),
    async getClassSlots(data) {
      this.selectedClassId = get(data.class, 'id', '')
      this.setSelectedClassId(this.selectedClassId)
      if (this.selectedClassId) {
        const { start, end } = this.getFirstAndLastDayOfMonth(new Date().toISOString())
        const res = await this.fetchOneClass(this.selectedClassId)
        await this.fetchLessons({ class: get(data.class, 'id', ''), date_gte: start, date_lte: end })
        this.schedule = get(res, 'schedule', [])
        this.scheduleType = get(res, 'scheduleType', 'weekly-schedule')
        this.classData = res
      }
    },
    getFirstAndLastDayOfMonth(yearMonth) {
      const date = moment(yearMonth, 'YYYY-MM')

      const start = date.startOf('month').toISOString()
      const end = date.endOf('month').toISOString()

      return { start, end }
    },
  },
  beforeDestroy() {
    this.setSelectedClassId('')
  },
}
</script>
<style lang="scss" scoped></style>
